import axios from 'axios'
import {myLocalStorage} from '@/utils/storage'
import router from '../router'
import { Toast } from 'vant';
let request = axios.create({
 // baseURL: urls[Math.floor(Math.random()*urls.length)],
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8;',
    'Authorization':'Basic Y3RwYXJrOmN0cGFyaw=='
    // 'Content-Type': 'application/x-www-form-urlencoded',
  }
})

request.interceptors.request.use(config => {
    let authority = null;
    // try {
    //   authority = myLocalStorage.getItem('empInfo').session;
    // } catch (error) {
    //   console.log(error);
    // }
    config.headers.authority = authority;
    return config;
  },
  error => {
    const {
      response
    } = error;
    console.log(94, response);
    if (response) {
      // 请求已发出，但是不在2xx的范围 errorHandle为解析错误码
      errorHandle(response.status, response.data.message);
      return Promise.reject(response);
    } else {
        //提示网络异常
        Toast.fail('网络异常');
        console.log("--------------网络异常-----------------");
    }
  })
request.interceptors.response.use(data => {
  if (data.data.code == 886) {
    // 886为session失效：
    myLocalStorage.removeItem('empInfo');
    router.push('/');
    Toast.fail('登录状态过期，请重新登录');
//     Message({message: '', type: 'warning'});
  } else if (data.data.code == 200) {
    // 200为请求成功
  } else if(data.data.code == 404){
   //Message("没有找到相关数据，请换个条件试试",);
    console.log(data.data);
 } else if(data.data.code == 201){
      router.push("/");
      Toast.alert('请先注册登录，在使用该功能!');
  } else if(data.data.code == 202 ||data.data.code == 203 ){
   //自定义返回
    console.log(data.data);
  } 
  else if(data.data.code == 500){
  //自定义返回
    console.log(data.data);
  } 
  else{
    // 其他稀奇古怪的情况
    console.log(data.data);
    //Toast.fail(data.data.msg);
    //Message({message: data.data.msg,duration:'800'});
    return 
   }
  return data.data;
},  error => {
    const {
      response
    } = error;
    console.log(94, response);
    if (response) {
      // 请求已发出，但是不在2xx的范围 errorHandle为解析错误码
      errorHandle(response.status, response.data.message);
      return Promise.reject(response);
    } else {
        //提示网络异常
        Toast.fail('网络异常');
        console.log("--------------网络异常-----------------");
    }
    //   return Promise.reject(error);
  })

export default {
  get (url, data) {
    return request.get(url, data);
  },
  post (url, data) {
    return request.post(url, data);
  },
  put (url, data) {
    return request.put(url, data);
  },
  delete (url, data) {
    return request.delete(url, data);
  }
}



// WEBPACK FOOTER //
// ./src/http/request.js